import { Status } from '@/models/status.model';
import Vue from 'vue';
import Component from 'vue-class-component';
import { FILESCACHE_KEYS } from '@/shared/plugins/files-cache/enums/files-cache.enum';

@Component({})
export default class StorageAdminView extends Vue {

    public status: Status = new Status();
    public saving: boolean = false;
    public saved: boolean = false;
  
  
    get visibilityDisclamer(): string {
      let disclamer = this.$i18n.t(
        'tools.storageAdmin.localStorageDisclamer');
      return String(disclamer);
    }

    async clearLocalStorage() {
      this.saving = true;
      await this.$BuilderCache.removeAllStore(FILESCACHE_KEYS.BUILDER_DATA);
      await this.$BuilderCache.removeAllStore(FILESCACHE_KEYS.BUILDER_TEMPLATES);
      await this.$BuilderCache.removeAllStore(FILESCACHE_KEYS.BUILDER_QUEUE);
      this.saving = false;
      this.saved = true;
    }

  
    created() {
      this.status.setLoad();
    }

}